import * as React from "react"
const Horror = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M13.714 14.11c0 1.112-.602 2.015-1.344 2.015-.742 0-1.344-.903-1.344-2.016 0-1.112.602-2.015 1.344-2.015.742 0 1.344.903 1.344 2.015Zm8.062 0c0 1.112-.602 2.015-1.343 2.015-.742 0-1.344-.903-1.344-2.016 0-1.112.602-2.015 1.344-2.015.741 0 1.343.903 1.343 2.015Z"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M16.401 1.68c-8.006 0-14.445 6.677-14.445 14.848v9.975c0 2.482 2.57 4.196 4.828 3.034a2.78 2.78 0 0 1 2.861.184 4.8 4.8 0 0 0 5.45 0l.475-.325a1.457 1.457 0 0 1 1.663 0l.474.325a4.8 4.8 0 0 0 5.45 0 2.781 2.781 0 0 1 2.863-.184c2.257 1.162 4.827-.554 4.827-3.034v-9.974c0-8.172-6.44-14.85-14.446-14.85ZM3.971 16.528c0-7.115 5.593-12.833 12.43-12.833s12.43 5.718 12.43 12.833v9.975c0 1.072-1.061 1.669-1.89 1.241a4.796 4.796 0 0 0-4.924.316 2.783 2.783 0 0 1-3.169 0l-.474-.326a3.473 3.473 0 0 0-3.945 0l-.475.325a2.783 2.783 0 0 1-3.168 0 4.798 4.798 0 0 0-4.925-.315c-.83.428-1.89-.169-1.89-1.241v-9.975Z"
      clipRule="evenodd"
    />
  </svg>
)
export default Horror